/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_NoneInputs */

const en_us2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No second goal`)
};

const pt_br2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem segundo objetivo`)
};

const es_419_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin segundo objetivo`)
};

const pt_pt2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem segundo objetivo`)
};

const fr_fr2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de second objectif`)
};

const de_de2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein zweites Ziel`)
};

const it_it2_onboarding_secondary_goal_none = /** @type {(inputs: Onboarding_Secondary_Goal_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun secondo obiettivo`)
};

/**
* | output |
* | --- |
* | "No second goal" |
*
* @param {Onboarding_Secondary_Goal_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_none = /** @type {((inputs?: Onboarding_Secondary_Goal_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_none(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_none(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_none(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_none(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_none(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_none(inputs)
	return en_us2_onboarding_secondary_goal_none(inputs)
});
export { onboarding_secondary_goal_none as "onboarding.secondary_goal.none" }